export { default as AdminListTableDesktop } from './AdminListTableDesktop';

export type {
  AdminListTableDesktopProps,
  AdminListTableDesktopComponent,
} from './AdminListTableDesktop.type';
